import { Page } from '@/components/molecules'
import { usePageTracking } from '@/hooks'

export const Component = () => {
  usePageTracking()

  return <Page title="Protocol">Protocol</Page>
}
